/**
 * Company: SPHMedia
 * Description: International Global Layout
 */

import { ReactElement } from "react";
import { Helmet } from "react-helmet-async";
import { VerticalProps } from "@app/types/Verticals";
import Breadcrumb from "@components/Breadcrumb/Breadcrumb";
import Container from "@components/Container/Container";
import Column from "@components/Grid/Column";
import Row from "@components/Grid/Row";
import Header from "@components/Header/Header";
import {
  BT_NEWSLETTERS,
  NEWSLETTER_TYPE,
} from "@components/Newsletter/types/Newsletter";
import NewsletterSignUpPanel from "@components/Newsletter/Verticals/NewsletterSignUp";
import LatestStoriesRow from "@pages/Section/components/VerticalMeta/LatestStoriesRow";
import TopStoriesRow from "@pages/Section/components/VerticalMeta/TopStoriesRow";
import { sectionNavigationItems } from "@util/constant";

import GarageBanner from "./components/GarageBanner";
import GarageKeywordStoriesRow from "./components/GarageKeywordStoriesRow";
import GarageNewsletterDescription from "./components/GarageNewsletterDescription";

export default function GarageVertical({
  context,
  mostReadArticles,
}: VerticalProps): ReactElement {
  const {
    data: { title, topStories, additional },
  } = context;

  return (
    <div className="w-full">
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <Header />

      <div className="flex-none bg-[var(--digital-breadcrumb-light-gray)]">
        <Breadcrumb
          rootClassName="m-auto container"
          parentCategory="international"
          childCategory="global"
          categoryDataMapping={sectionNavigationItems}
        />
      </div>

      <GarageBanner />

      <Container rootClassName="mt-6 px-3">
        <TopStoriesRow
          parentCategory="startups-tech/startups"
          articles={topStories}
          verticalName="garage"
        />

        <LatestStoriesRow
          articles={topStories.slice(4, 9)}
          seeMoreLink="/startups-tech/startups/latest"
          verticalName="garage"
          mostReadStories={mostReadArticles}
        />

        <Row rootClassName="w-full mb-12">
          <Column rootClassName="w-full lg:w-1/2">
            <GarageKeywordStoriesRow
              seeMoreLink="/keywords/5-questions"
              data={additional.at(0)}
              verticalName="garage"
              verticalBlockTitle="5-QUESTIONS"
            />
          </Column>

          <Column rootClassName="w-full lg:w-1/2">
            <GarageKeywordStoriesRow
              seeMoreLink="/keywords/startup-funding"
              data={additional.at(1)}
              verticalName="garage"
              verticalBlockTitle="STARTUP FUNDING"
            />
          </Column>
        </Row>
      </Container>

      <NewsletterSignUpPanel
        rootClassName="mb-3"
        descriptionComponent={<GarageNewsletterDescription />}
        newsletter={BT_NEWSLETTERS.filter(
          (newsletter) => newsletter.type === NEWSLETTER_TYPE.GARAGE
        )}
        btnColors="bg-verticals-garage text-white hover:bg-white hover:text-verticals-garage"
        linkColors="text-verticals-garage"
      />

      {/* Placeholder for Garage footer banner component, will be replaced once done */}
    </div>
  );
}
